import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import BaseForm from '../form/base-form';
import {validateRequiredFields, validateEmail} from '../../utils/form';
import Button from '../button';
import LocalizedStrings from '../../localization/strings';
import Alert from '../alert';

const fields = ['email', 'password'];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'email', 'password'
    ], errors);
    errors = validateEmail(values, 'email', errors);

    return errors;
}

class LoginForm extends BaseForm {
    showAlert() {
        return false;
    }

    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                email,

                password
            }
        } = this.props;
        return (
            <div className="login-form">
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    <FormField label={LocalizedStrings.email} name="email" error={email.visited && email.error}
                               field={email}>
                        <input ref="email" className="border-full larger" placeholder={LocalizedStrings.email}
                               type="email" {...email}/>
                    </FormField>

                    <FormField label={LocalizedStrings.password} name="password"
                               error={password.visited && password.error} field={password}>
                        <input ref="password" className="border-full larger" placeholder={LocalizedStrings.password}
                               type="password" {...password}/>
                    </FormField>

                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting}>
                            {LocalizedStrings.login}
                        </Button>
                    </div>
                </form>
            </div>
        )
    }
}

export default reduxForm({form: 'login-form', fields, validate, destroyOnUnmount: true})(LoginForm);



// WEBPACK FOOTER //
// ./src/js/components/user/login-form.js